/* Sync xo-active state from triggers to content elements for collection-list-5.
   The original xo-collection-tabs JS toggles xo-active on triggers and tries
   to AJAX-fetch the section per collection. That fetch 404s on this store, so
   we render every collection's content statically and switch by toggling
   xo-active on .collection-list-5__tab-content elements via this listener. */
(function () {
  'use strict';

  function activate(tabsEl, handle) {
    if (!tabsEl || !handle) return;
    var contents = tabsEl.querySelectorAll('.collection-list-5__tab-content');
    contents.forEach(function (c) {
      if (c.getAttribute('xo-handle') === handle) {
        c.setAttribute('xo-active', '');
      } else {
        c.removeAttribute('xo-active');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest
      ? e.target.closest('xo-collection-tabs-trigger')
      : null;
    if (!trigger) return;
    var tabs = trigger.closest('xo-collection-tabs');
    var handle = trigger.getAttribute('xo-handle');
    if (!tabs || !handle) return;
    // Ensure this is our collection-list-5 instance (not some other tabs)
    if (!tabs.querySelector('.collection-list-5__tab-content')) return;
    activate(tabs, handle);
  });

  // Initial sync (just in case)
  function init() {
    document.querySelectorAll('xo-collection-tabs').forEach(function (tabs) {
      if (!tabs.querySelector('.collection-list-5__tab-content')) return;
      var active = tabs.querySelector('xo-collection-tabs-trigger[xo-active]');
      if (!active) return;
      activate(tabs, active.getAttribute('xo-handle'));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
